import { getTopupVoucher, getRefundVoucher, getAdjustmentVoucher } from "apis/siigo.api";
import { DataTable, Pill, Text, ButtonLink } from "components/commons";
import { useApi, useMount, useRouter } from "hooks";
import React, { useCallback, useMemo } from "react";
import { HeaderA } from "components/headers";
import { ModuleWrapper } from "components/fragments";
import { PillType } from "enums";
import { Path } from "paths";
import { ArtOctopus } from "images";
import {
  RefundVoucherDetailColumns,
  TopupVoucherDetailColumns,
  AdjustmentVoucherDetailColumns,
} from "./columns";

const VoucherTransactionDetails = () => {
  const { query } = useRouter();
  const { id, vouchertype } = query;

  const VoucherType = {
    TOPUP: "TOPUP",
    REFUND: "REFUND",
    ADJUSTMENT: "ADJUSTMENT",
  };
  const history = useRouter();
  const {
    request: searchvoucherRequest,
    loading: loadingSearchvoucher,
    result,
  } = useApi({
    api:
      vouchertype === VoucherType.REFUND.toLocaleLowerCase()
        ? getRefundVoucher
        : vouchertype === VoucherType.TOPUP.toLocaleLowerCase()
          ? getTopupVoucher
          : getAdjustmentVoucher,
    isArray: false,
    params: {
      voucherId: id,
    },
  });

  useMount(() => {
    searchvoucherRequest();
  }, [id, vouchertype]);

  useMount(() => {
    searchvoucherRequest();
  }, []);

  const renderVoucher = useCallback(
    (name) => <ButtonLink className="text-left">{name}</ButtonLink>,
    [],
  );
  const renderStatus = useCallback((status) => {
    // if (status === VoucherStatus.Active) {
    //   return (
    //     <Pill type={PillType.Green} size="text-xs">
    //       {prettifyVoucherStatus(status)}
    //     </Pill>
    //   );
    // }
    // if (status === VoucherStatus.Inactive) {
    //   return (
    //     <Pill type={PillType.Opaque} size="text-xs">
    //       {prettifyVoucherStatus(status)}
    //     </Pill>
    //   );
    // }
    // return (
    //   <Pill type={PillType.Gray} size="text-xs">
    //     {prettifyVoucherStatus(status)}
    //   </Pill>
    // );
    return (
      <Pill type={PillType.Green} size="text-xs">
        {status}
      </Pill>
    );
  }, []);

  const renderDateCreated = useCallback((dateCreated) => {
    return (
      <div>
        <Text>{dateCreated?.date}</Text>
        {dateCreated?.time && <Text color="text-gray">{dateCreated.time}</Text>}
      </div>
    );
  }, []);

  const parseDateTime = useCallback((dateTimeStr) => {
    if (!dateTimeStr) return {};
    const [date, time] = dateTimeStr.split("T");
    return { date, time };
  }, []);

  const renderGuestName = useCallback(
    (guestName, userTagUid, count) => (
      <div
        className="cursor-pointer group"
        onClick={() => {
          history.push(Path.GUEST);
        }}
      >
        <Text className="group-hover:text-gray">{guestName}</Text>
        <Text className="group-hover:text-gray" tagUid>
          {userTagUid}
        </Text>
        <Text className="group-hover:text-gray" tagUseCount>
          {count}
        </Text>
      </div>
    ),
    [history],
  );

  const renderTransactionId = useCallback(
    (transactionId) => (
      <ButtonLink path={Path.TRANSACTION_ID(transactionId)}>#{transactionId}</ButtonLink>
    ),
    [],
  );

  const prepareVoucherList = useCallback(() => {
    if (!result?.data) return [];
    const dataArray = Array.isArray(result.data) ? result.data : [result.data];
    return dataArray.map((voucher) => {
      const {
        transactionId,
        voucherId,
        voucherDate,
        guestName,
        guestTagUid,
        tagUseCount,
        voucherType,
        amount,
      } = voucher;
      return {
        transactionId: renderTransactionId(transactionId),
        voucherId: renderVoucher(voucherId),
        voucherType: renderStatus(voucherType),
        voucherDate: renderDateCreated(parseDateTime(voucherDate)),
        guestName: renderGuestName(guestName, guestTagUid, tagUseCount),
        amount,
      };
    });
  }, [
    result,
    renderStatus,
    renderDateCreated,
    parseDateTime,
    renderGuestName,
    renderTransactionId,
    renderVoucher,
  ]);

  const vouchers = useMemo(() => {
    return prepareVoucherList();
  }, [prepareVoucherList]);

  return (
    <ModuleWrapper>
      <HeaderA title={<>{vouchertype.toLocaleUpperCase()} Voucher</>} className="mb-md" />
      {vouchers && (
        <DataTable
          page={1}
          pageSize={20}
          total={vouchers.length}
          loading={loadingSearchvoucher}
          columns={
            vouchertype === VoucherType.REFUND.toLocaleLowerCase()
              ? RefundVoucherDetailColumns
              : vouchertype === VoucherType.TOPUP.toLocaleLowerCase()
                ? TopupVoucherDetailColumns
                : AdjustmentVoucherDetailColumns
          }
          data={vouchers}
          minWidth="900px"
        />
      )}
    </ModuleWrapper>
  );
};

export default VoucherTransactionDetails;
